import { Button, styled } from "@periplus/ui-library";

export default styled(Button)(({ theme, variant }) => ({
    ...(variant === "secondary" && {
        backgroundColor: "white"
    })
}));
